import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatMetricAmount = createCustomElementWrapper('kat-metric-amount', 'KatMetricAmount', {}, {});
